import Swiper, { EffectFade, Thumbs, Scrollbar } from "swiper";

const navSliderWorkflow = new Swiper(".workflow-carousel .slider-navigation", {
  spaceBetween: 0,
  slidesPerView: "auto",
  freeMode: true,
  watchSlidesProgress: true,
  cssMode: true,
  threshold: 10,
});
const contentSliderWorkflow = new Swiper(".workflow-carousel .slider-content", {
  modules: [EffectFade, Thumbs, Scrollbar],
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  thumbs: {
    swiper: navSliderWorkflow,
  },
  autoHeight: true,
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
  on: {
    init() {
      this.slides.forEach(function (slide, i) {
        slide.setAttribute("data-index", i);
      });
    },
  },
});

navSliderWorkflow.on("slideChange", function () {
  const currentSlide = navSliderWorkflow.slides[navSliderWorkflow.activeIndex].dataset.index;
  contentSliderWorkflow.slideTo(currentSlide, 500, true);
});

navSliderWorkflow.on("tap", function () {
  const currentSlide = navSliderWorkflow.clickedIndex;
  contentSliderWorkflow.slideTo(currentSlide, 500, true);
});

contentSliderWorkflow.on("slideChange", function () {
  const currentSlide = contentSliderWorkflow.slides[contentSliderWorkflow.activeIndex].dataset.index;
  navSliderWorkflow.slideTo(currentSlide, 500, true);
});

contentSliderWorkflow.on("tap", function () {
  const currentSlide = contentSliderWorkflow.clickedIndex;
  navSliderWorkflow.slideTo(currentSlide, 500, true);
});

// Hotfix for the slider-inner height incorrect calculation on mobile resolutions
document.addEventListener( 'DOMContentLoaded', () => {

  if (window.innerWidth < 768) {
    setTimeout(() => {
      const sliderInner = document.querySelector( '.workflow-carousel .slider-content .slider-inner' );
      const sliderInnerSlideItem = document.querySelector( '.workflow-carousel .slider-content .slider-inner .workflow-carousel-slide' );
    
      // console.log('sliderInnerSlideItem => ', sliderInnerSlideItem.offsetHeight);
      // console.log('sliderInner => ', sliderInner.offsetHeight );
    
      if (sliderInnerSlideItem.offsetHeight > sliderInner.offsetHeight) {
        sliderInner.style.height = sliderInnerSlideItem.offsetHeight + 'px';
      }  
    }, 1500);
  }
});